import {
  createRaveConverter,
  createRaveReviewConverter,
  createRaveRedemptionCodeConverter,
  createAudioChunkConverter,
  Rave,
  createRaveConfigConverter,
  createDraftRaveConverter,
  DraftRave,
  createRaveVideoAssetConverter,
} from "@t3/shared";
import {
  DocumentData,
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  serverTimestamp,
} from "firebase/firestore";

export const raveConverter = createRaveConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp) as FirestoreDataConverter<Rave, DocumentData>;

export const raveDraftConverter = createDraftRaveConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp) as FirestoreDataConverter<DraftRave, DocumentData>;

export const raveReviewConverter = createRaveReviewConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp);

export const raveRedemptionCodeConverter = createRaveRedemptionCodeConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp);

export const audioChunkConverter = createAudioChunkConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp);

export const raveVideoAssetConverter = createRaveVideoAssetConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp);

export const raveConfigConverter = createRaveConfigConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp);
